import React from 'react';
import { useTranslation } from 'react-i18next';

function getSentiment(direction) {
  if (!direction) return 'neutral';
  const d = direction.toLowerCase();
  if (d === 'bullish' || d === 'long' || d === 'buy') return 'bullish';
  if (d === 'bearish' || d === 'short' || d === 'sell') return 'bearish';
  return 'neutral';
}

function formatTimestamp(ts, t) {
  if (!ts) return '';
  const d = new Date(ts);
  if (isNaN(d.getTime())) return '';
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return t('stats.justNow');
  if (diffMin < 60) return t('stats.mAgo', { count: diffMin });
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return t('stats.hAgo', { count: diffH });
  const diffD = Math.floor(diffH / 24);
  return t('stats.dAgo', { count: diffD });
}

function AiCommentaryPanel({ aiCommentary }) {
  const { t } = useTranslation();
  const items = aiCommentary || [];

  return (
    <div className="stats-panel stats-ai-panel">
      <div className="stats-panel-header">
        <span className="stats-panel-title">{t('stats.aiCommentary')}</span>
      </div>

      {items.length === 0 ? (
        <div className="stats-ai-empty">{t('stats.noAiInsights')}</div>
      ) : (
        <div className="stats-ai-list">
          {items.map((item, i) => {
            const sentiment = getSentiment(item.direction);
            const text = item.logMessage || item.reasoning || t('stats.noCommentary');
            return (
              <div key={i} className={`stats-ai-item ${sentiment}`}>
                <div className="stats-ai-header">
                  <span className={`stats-ai-tag ${sentiment}`}>
                    {item.direction || 'neutral'}
                  </span>
                  <span className="stats-ai-time">
                    {formatTimestamp(item.timestamp, t)}
                  </span>
                </div>
                <div className="stats-ai-txt">{text}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export { getSentiment, formatTimestamp };
export default AiCommentaryPanel;
